import stringSimilarity from 'string-similarity';

export const checkText: Object<String> = {
    'DonorBox': 'Open donorbox',
    'RDonorBox': 'Remove donorbox',
    'clicknPledge': 'Open click and pledge',
    'RclicknPledge': 'Remove click and pledge',
    'Recording': 'Open recording',
    'Livestream': 'Open livestream',
    'WhiteBoard': 'Open whiteboard',
    'LivePad': 'Open LivePad',
    'CLivePad': 'Close LivePad',
    'CWhiteBoard': 'Close Whiteboard',
    'ScreenShare': 'Start Screen sharing',
    'StopScreen': 'Stop Screen sharing',
    'Youtube': 'Open YouTube',
    'CYoutube': 'Close YouTube',
    'ParticipantP': 'Open Participant pane',
    'VcDialog': 'open virtual background',
    'ChatBox': 'open chat box',
    'VideoQ': 'open video quality dialog',
    'SpeckerS': 'open speaker stats',
    'Settings': 'Open settings',
    'Fullscreen': 'Open full screen',
    'InviteP': 'Invite People',
    'RaiseHand': 'Raise Hand',
    'LowerHand': 'Lower Hand',
    'MuteAudio': 'Mute audio',
    'UnmuteAudio': 'Unmute audio',
    'MuteVideo': 'Turn off camera',
    'UnmuteVideo': 'Turn on camera'
};

export const commandAliases = {
    'DonorBox': [ 'open donorbox', 'donorbox' ],
    'RDonorBox': [ 'remove donorbox', 'close donorbox' ],
    'clicknPledge': [ 'open click and pledge', 'click and pledge', 'open click n pledge', 'click n pledge' ],
    'RclicknPledge': [ 'remove click and pledge', 'close click and pledge' ],
    'Recording': [ 'open recording', 'start recording', 'recording' ],
    'Livestream': [ 'open livestream', 'start livestream', 'livestream' ],
    'WhiteBoard': [ 'open whiteboard', 'whiteboard' ],
    'LivePad': [ 'open livepad', 'livepad' ],
    'CLivePad': [ 'close livepad' ],
    'CWhiteBoard': [ 'close whiteboard' ],
    'ScreenShare': [
        'start screen sharing',
        'start screen share',
        'start screenshare',
        'open screen share',
        'open screen sharing',
        'open screenshare',
        'screen share',
        'screenshare',
        'share screen',
        'start sharing screen',
        'share my screen',
        'open share screen'
    ],
    'StopScreen': [
        'stop screen sharing',
        'stop screen share',
        'stop screenshare',
        'close screen share',
        'close screen sharing',
        'close screenshare',
        'stop sharing screen',
        'stop sharing'
    ],
    'Youtube': [ 'open youtube', 'youtube' ],
    'CYoutube': [ 'close youtube', 'stop youtube' ],
    'ParticipantP': [
        'open participant pane',
        'open participants pane',
        'participant pane',
        'participants pane',
        'open participants',
        'participants'
    ],
    'VcDialog': [ 'open virtual background', 'virtual background', 'change background' ],
    'ChatBox': [ 'open chat box', 'chat box', 'open chat', 'chat' ],
    'VideoQ': [ 'open video quality dialog', 'open video quality', 'video quality' ],
    'SpeckerS': [ 'open speaker stats', 'speaker stats' ],
    'Settings': [ 'open settings', 'settings' ],
    'Fullscreen': [ 'open full screen', 'full screen', 'fullscreen', 'exit full screen' ],
    'InviteP': [ 'invite people', 'invite person', 'invite' ],
    'RaiseHand': [ 'raise hand', 'raise my hand', 'hand raise', 'hand raised', 'put hand up' ],
    'LowerHand': [ 'lower hand', 'lower my hand', 'put hand down', 'hand down' ],
    'MuteAudio': [ 'mute audio', 'mute microphone', 'mute mic', 'mute', 'turn off microphone', 'turn off mic', 'mic off' ],
    'UnmuteAudio': [ 'unmute audio', 'unmute microphone', 'unmute mic', 'unmute', 'turn on microphone', 'turn on mic', 'mic on' ],
    'MuteVideo': [ 'turn off camera', 'camera off', 'turn off video', 'video off', 'stop video', 'mute video' ],
    'UnmuteVideo': [ 'turn on camera', 'camera on', 'turn on video', 'video on', 'start video', 'unmute video' ]
};

/**
 * Finds the best matching voice command for a given raw input string.
 *
 * @param {string} rawInput - The transcript text to match.
 * @returns {?{key: string, rating: number, phrase: string}} - Matched command info or null.
 */
export const findMatchingVoiceCommand = (rawInput: string) => {
    if (!rawInput || typeof rawInput !== 'string') {
        return null;
    }

    // Normalize: lowercase, remove punctuation, collapse extra spaces
    const cleanInput = rawInput
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    if (!cleanInput) {
        return null;
    }

    // 1. Direct exact match with any alias
    for (const [ commandKey, phrases ] of Object.entries(commandAliases)) {
        for (const phrase of phrases) {
            const cleanPhrase = phrase.toLowerCase().replace(/[^a-z0-9\s]/g, '')
.trim();

            if (cleanInput === cleanPhrase) {
                return {
                    key: commandKey,
                    rating: 1.0,
                    phrase
                };
            }
        }
    }

    // 2. Fuzzy match with stringSimilarity against all aliases
    let bestKey = null;
    let bestRating = 0;
    let bestPhrase = null;

    for (const [ commandKey, phrases ] of Object.entries(commandAliases)) {
        for (const phrase of phrases) {
            const cleanPhrase = phrase.toLowerCase().replace(/[^a-z0-9\s]/g, '')
.trim();
            const rating = stringSimilarity.compareTwoStrings(cleanInput, cleanPhrase);

            if (rating > bestRating) {
                bestRating = rating;
                bestKey = commandKey;
                bestPhrase = phrase;
            }
        }
    }

    if (bestRating >= 0.5) {
        return {
            key: bestKey,
            rating: bestRating,
            phrase: bestPhrase
        };
    }

    return null;
};
